<script>
export default {
  name: 'ProductDetails',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      quantity: 1,
      shouldShowConfirm: false,
    }
  },
  computed: {},
  methods: {
    calculateTotal() {
      return this.quantity * this.product.price
    },
    buy() {
      this.shouldShowConfirm = true
    },
    confirm() {
      this.$emit('close')
      this.$emit('buy-product', {
        product_id: this.product.id,
        quantity: this.quantity,
      })
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="product-details bg-white rounded-xl mx-auto shadow-box relative left-0 flex justify-between overflow-hidden"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <div v-show="!shouldShowConfirm" class="mb-5">
        <img
          :src="product.image_url"
          class="w-full rounded-b-none rounded-xl"
        />
        <div class="px-8 pb-3">
          <div class="flex justify-between -mt-8">
            <div class="flex">
              <div
                class="rounded-full bg-white shadow-datestamp w-22 h-22 text-center align-middle mr-4"
              >
                <div
                  class="text-32xl leading-22 text-blue-darker mx-auto align-middle"
                >
                  {{ product.price }}
                </div>
              </div>
              <div class="text-blue-light text-lg align-middle pt-10">
                PENCIL Points
              </div>
            </div>
          </div>
          <div class="text-gray-light text-2xl mt-3">
            {{ product.title }}
          </div>
          <div class="flex justify-between">
            <div class="mt-3">
              <p class="my-3 text-black text-basel">{{
                product.description
              }}</p>
            </div>
          </div>
          <div class="mt-3">
            <div class="text-blue-darker text-base">
              Available: {{ product.stock }}
            </div>
          </div>
          <div class="mt-3">
            <div class="text-blue-darker text-base">
              Quantity:
              <input
                v-model="quantity"
                type="number"
                step="1"
                min="1"
                :max="product.stock"
                class="input w-20"
              />
            </div>
          </div>
          <div class="mt-3">
            <div class="text-blue-darker text-base">
              Total: {{ calculateTotal() }} PENCIL Points
            </div>
          </div>
          <div class="mt-3">
            <button
              class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
              @click="buy"
              >Buy</button
            >
            <button
              class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
              @click="$emit('close')"
              >Cancel</button
            >
          </div>
        </div>
      </div>
      <div v-show="shouldShowConfirm" class="mb-5">
        <div class="px-8 pb-3">
          <div class="text-gray-light text-2xl mt-10">
            Confirmation
          </div>
          <div class="flex justify-between">
            <div class="mt-3">
              <p class="my-3 text-black text-basel">
                Please confirm that you want to redeem
                <span class="font-bold">{{ calculateTotal() }}</span> Kynd
                Points for
                <span class="font-bold">{{ product.title }}.</span></p
              >
              <p class="my-3 text-black text-basel font-bold">
                This cannot be undone.</p
              >
            </div>
          </div>
          <div class="mt-3">
            <button
              class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
              @click="confirm"
              >Confirm</button
            >
            <button
              class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
              @click="$emit('close')"
              >Cancel</button
            >
          </div>
        </div>
      </div>
    </template>
  </BaseModalWindow>
</template>
